import { Service } from "typedi";
import { WebCategoryRuleValueStoreEvaluationResult } from "../../../../../schools-backend/src/rule/application/stores/ruleValueStores/WebCategoryRuleValueStore";
import { AgentRPCCommand } from "../../../../shared/RPC/AgentRPCCommand";
import { AgentRPCCommands } from "../../../../shared/RPC/AgentRPCCommands";
import { UrlEvaluator } from "../state/UrlEvaluator";

@Service()
export class UrlWebCategorizationChanged implements AgentRPCCommand<"url.web.categorization.changed"> {
    constructor(
        agentRPCCommands: AgentRPCCommands,
        private readonly urlEvaluator: UrlEvaluator
    ) {
        agentRPCCommands.register("url.web.categorization.changed", this);
    }

    async run(url: string, result: WebCategoryRuleValueStoreEvaluationResult): Promise<void> {
        this.urlEvaluator.invalidate(url, result);
    }
}
